<template>
    <!-- 未中奖，积分，优惠券，代金券弹窗样式 -->
    <div v-if="isVisibility"
        class="general-award-view">
        <!-- 未中奖 -->
        <div v-if="popupType === NBBAwardPopupType.noAward"
            class="no-award">
            <div :class="['content-winningPrize-content', styleType === '3' ? 'high' : 'middle']"
                :style="{backgroundImage: 'url(' + drawPointUrl + ')'}">
                <div class="no-award-desc">很遗憾未中奖！</div>
            </div>
            <div class="content-winningPrize-buttom"
                :style="{'background': buttonColor, 'color': buttonTextColor}"
                @click="getGift">确定</div>
        </div>
        <!-- 其他奖品 -->
        <div v-else>
            <!-- 标题 -->
            <div class="content-winningPrize-title">恭喜您获得</div>
            <!-- 奖品信息展示区 -->
            <div :class="['content-winningPrize-content', styleType === '3' ? 'high' : 'middle']"
                :style="{backgroundImage: 'url(' + drawPointUrl + ')'}">
                <!-- 奖品图片 -->
                <img class="content-winningPrize-goodsPictureUrl"
                    :src="goodsPictureUrl"
                    alt="">
                <!-- 奖品名称 -->
                <div class="content-winningPrize-text">{{ currentAward.goodsName || currentAward.rewardName }}</div>
                <!-- 奖品描述 -->
                <div class="content-winningPrize-dec">{{ currentAward.rewardDescri }}</div>
            </div>
            <!-- 按钮区 -->
            <div v-if="isInMiniProgram || loginType === BWC.LoginType.Alipay"
                class="content-winningPrize-buttom"
                :style="{'background': buttonColor, 'color': buttonTextColor}"
                @click="getGift">{{ buttonText }}</div>
            <div v-if="!isInMiniProgram && loginType === BWC.LoginType.Wechat"
                class="content-winningPrize-buttom"
                :style="{'background': buttonColor, 'color': buttonTextColor}">
                {{ buttonText }}
                <div class="content-winningPrize-buttom-wechat">
                    <div class="wxOpenLaunchWeapp"
                        v-html="wxOpenLaunchWeappHiHonor"></div>
                </div>
            </div>
        </div>

        <!-- 关闭图标 -->
        <div class="content-winningPrize-close-page"
            @click="close">
            <img class="content-winningPrize-close-page-img"
                src="../../../../../../../../static/runtime/images/magic/timedDraw/close.png">
        </div>
    </div>
</template>
<script>
import { BigWheelConstants as BWC, NBBAwardPopupType } from '../../../common/global-variable';
import { config as configEnv } from '../../../../../../../commons/config.js';
import { config } from '@/api/config.js';
import {queryNeedNotifyAwardInfo} from "../../../../../../../commons/commonJudgeIsNeedNotify.js"
export default {
  name: 'GeneralAwardView',
  props: {
    // 接口queryActivityBigWheelActivityDetailH5返回的活动信息
    activityInfoObj: {
      type: Object,
      default: {},
    },
    // 当前中奖奖品
    currentAward: {
      type: Object,
      default: {},
    },
    // 是否在小程序内
    isInMiniProgram: {
      type: Boolean,
      default: false,
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    // 弹窗展示奖品类型
    popupType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      BWC: BWC,
      NBBAwardPopupType: NBBAwardPopupType,
      wxOpenLaunchWeappHiHonor: '',
      env: configEnv.env === 'pro' ? 'release' : 'trial',
      isVisibility: false,
      queryNeedNotityFlag: false, //如果1s内关闭奖品弹窗或者其他操作，则不会查询奖品是否需要订阅到期提醒
      styleType: '',
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  created() {
    if (!this.isInMiniProgram) {
      this.wxOpenLaunchWeappHiHonor = `<wx-open-launch-weapp id="launch-btn" env-version="${this.env}" username="${this.hiHonorWxAppId}" path="subpackages/my/pages/rewardQuery/reward-query"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
    }
    // awardListPosition 中奖奖品内容位置（1：低、2：中、3：高）
    this.styleType = this.activityInfoObj.activityConfig.awardListPosition;
  },
  computed: {
    // 弹窗背景图URL
    drawPointUrl() {
      const defaultUrl = '../../../../../../../../static/runtime/images/magic/timedDraw/backgroundImg.png';
      if (this.activityInfoObj.drawPointUrl) {
        return this.$utils.getImageUrl(JSON.parse(this.activityInfoObj.drawPointUrl).file) || defaultUrl;
      } else {
        return defaultUrl;
      }
    },
    goodsPictureUrl() {
      if (this.currentAward.goodsPictureUrl) {
        return this.$utils.getImageUrl(JSON.parse(this.currentAward.goodsPictureUrl).file);
      } else {
        return '';
      }
    },
    // 按钮颜色
    buttonColor() {
      if (this.activityInfoObj.activityConfig && this.activityInfoObj.activityConfig.buttonColor) {
        return this.activityInfoObj.activityConfig.buttonColor;
      } else {
        return '';
      }
    },
    // 按钮文本颜色
    buttonTextColor() {
      if (this.activityInfoObj.activityConfig && this.activityInfoObj.activityConfig.buttonTextColor) {
        return this.activityInfoObj.activityConfig.buttonTextColor;
      } else {
        return '';
      }
    },
    // 按钮文案
    buttonText() {
      // 奖品类型为积分，且跳转配置了自定义链接
      if (this.currentAward && (this.currentAward.goodsType === BWC.GoodsType.accumulatePoints || this.currentAward.rewardType === BWC.GoodsType.accumulatePoints) && this.currentAward.jumpType === BWC.JumpType.customLink) {
        return '去使用'
      } else {
        return '立即领取'
      }
    }
  },
  methods: {
    getGift() {
      this.queryNeedNotityFlag = false;
      this.$emit('GeneralAwardHandler');
    },
    close() {
      this.isVisibility = false;
      this.queryNeedNotityFlag = false;
      this.$emit('closeMask');
    },
    openModel(obj) {
      this.isVisibility = true;
      this.queryNeedNotityFlag = true;
      if(this.activityInfoObj.loginType === 'wechat' && this.activityInfoObj.enableMessageNotifications === '1' && this.popupType !== NBBAwardPopupType.noAward && obj && obj.businessType) {
        let countDown = 1;  //倒计时
        const timerId = setInterval(() => {
          if (countDown === 0) {
            clearInterval(timerId);
            if(this.queryNeedNotityFlag) {
              const params = [{
                goodsType : this.currentAward.goodsType,//0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
                collectionType: this.currentAward.collectionType,//领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
                businessId: this.currentAward.recordId,//普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
                businessType: obj.businessType, //业务类型 12.签到  7.专题活动 9.大转盘
                goodsId: this.currentAward.goodsId,
                bigWheelActivityType: this.activityInfoObj.bigWheelActivityType, // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 => 新盲盒
                drawWheelType: this.activityInfoObj.drawWheelType //大转盘抽奖类型 drawWheelType  1 => 普通抽奖   2 => 整点购抽奖   3 => 定时开奖
              }]
              queryNeedNotifyAwardInfo(params,this);
            }
          } else {
            countDown--;
          }
        }, 500);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.general-award-view {
  margin-top: -10vh;
  .content-winningPrize-title {
    font-size: 30px;
    text-align: center;
  }
  .content-winningPrize-content {
    width: 88vw;
    height: 39vh;
    margin-top: 1.6vh;
    background-size: 100% 100%;
    padding-top: 1.5vh;
    .content-winningPrize-goodsPictureUrl {
      width: 25.4vw;
      height: 11.7vh;
      display: block;
      margin: 0 auto;
    }
    .content-winningPrize-text {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      width: 180px;
      margin: 1vh auto 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
    .content-winningPrize-dec {
      color: #256fff;
      font-size: 12px;
      text-align: center;
      font-weight: 400;
      margin-top: 0.3vh;
    }
  }
  .high {
    padding-top: 1.5vh;
  }
  .middle {
    padding-top: 11.5vh;
  }
  .content-winningPrize-buttom {
    position: relative;
    width: 57.5vw;
    height: 5.8vh;
    margin: 2.1vh auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.9vh;
    .content-winningPrize-buttom-wechat {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
  .content-winningPrize-close-page {
    width: 24px;
    height: 24px;
    margin: 2.4vh auto 0;
    border: 1px solid #ffffff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .content-winningPrize-close-page-img {
      width: 12px;
      height: 12px;
      filter: drop-shadow(0 0 white);
    }
  }
  .no-award {
    padding-top: 45px;
  }
  .no-award-desc {
    color: #000000;
    font-size: 20px;
    text-align: center;
    margin-top: 50px;
    font-weight: bold;
    margin-left: 3vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/general-award-view.vue